<capacitor-google-map #map id='nomMap'></capacitor-google-map>